/**
 * Reglas del autoguardado del builder.
 *
 * Puro y sin React a propósito: son las decisiones que importan —cuándo vale la
 * pena escribir, y cuándo ofrecerle al operador recuperar lo suyo— y conviene
 * poder fijarlas con tests sin montar un árbol de componentes.
 */
/** Debajo de esto, "recién": no aporta un contador que cambia cada segundo. */
const SEGUNDOS_RECIEN = 30;
/**
 * El editor emite un cambio por pulsación; sin este filtro se escribiría un
 * objeto en S3 por cada tecla.
 */
export function debeGuardar({ actual, publicado, ultimoGuardado }) {
    // Mientras carga, el editor está vacío. Guardar ahí pisaría con nada un
    // borrador que sí tenía trabajo.
    if (!actual.trim())
        return false;
    // Ya guardamos exactamente esto.
    if (ultimoGuardado !== null && actual === ultimoGuardado)
        return false;
    // Sin nada guardado todavía, sólo vale la pena si difiere de lo publicado:
    // abrir y cerrar el editor no debería dejar un borrador.
    if (ultimoGuardado === null)
        return actual !== publicado;
    // Con algo ya guardado, cualquier cambio cuenta — incluido deshacer hasta
    // volver a lo publicado, que si no dejaría el borrador viejo vivo.
    return true;
}
/**
 * Si vale la pena ofrecer "recuperar lo que estabas editando".
 *
 * Compara por contenido, no por texto: el editor reformatea el JSON al abrirlo
 * y una diferencia de sangría no es trabajo sin guardar.
 */
export function hayBorradorRecuperable({ borrador, publicado, }) {
    if (borrador === null || !borrador.trim())
        return false;
    try {
        return JSON.stringify(JSON.parse(borrador)) !== JSON.stringify(JSON.parse(publicado));
    }
    catch {
        // Uno de los dos no es JSON válido — típicamente un borrador a medio
        // escribir. Se ofrece igual: descartarlo en silencio sería perder trabajo
        // sin preguntar.
        return true;
    }
}
/** Texto corto para el indicador: "recién", "hace 5 min", "hace 3 h", o la fecha. */
export function describirAntiguedad(savedAt, ahora = new Date()) {
    const ts = Date.parse(savedAt);
    if (Number.isNaN(ts))
        return '';
    const segundos = Math.max(0, Math.floor((ahora.getTime() - ts) / 1000));
    if (segundos < SEGUNDOS_RECIEN)
        return 'recién';
    const minutos = Math.floor(segundos / 60);
    if (minutos < 60)
        return `hace ${Math.max(1, minutos)} min`;
    const horas = Math.floor(minutos / 60);
    if (horas < 24)
        return `hace ${horas} h`;
    // Más de un día: la fecha ayuda más que "hace 37 h" a decidir si restaurarlo.
    return new Date(ts).toLocaleDateString('es-CL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}
//# sourceMappingURL=autosave.js.map